import { ArrowLeft } from 'lucide-react'

import { Button } from '@/components/ui/button'

interface PageHeaderProps {
  title: string
  description?: React.ReactNode
  action?: React.ReactNode
  backButton?: boolean
  onBack?: () => void
  tabs?: React.ReactNode
  logoSrc?: string
  logoSize?: 'sm' | 'md' | 'lg'
}

const PageHeader = ({ title, description, action, backButton, onBack, tabs, logoSrc, logoSize = 'md' }: PageHeaderProps) => {
  const logoSizeClass = logoSize === 'lg' ? 'w-12 h-12' : logoSize === 'sm' ? 'w-6 h-6' : 'w-8 h-8'
  return (
    <div className="relative mt-2">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-3">
          {backButton && onBack && (
            <Button
              variant="ghost"
              size="icon"
              onClick={onBack}
              className="hover:bg-white/80 transition-colors"
            >
              <ArrowLeft className="w-4 h-4" />
            </Button>
          )}
          {logoSrc && (
            <div className={`flex-shrink-0 ${logoSizeClass} bg-white rounded-lg shadow-sm border border-gray-100 flex items-center justify-center p-1.5`}>
              <img src={logoSrc} alt={`${title} logo`} className="w-full h-full object-contain" loading="lazy" />
            </div>
          )}
          <div>
            <h1 className="text-xl font-bold text-gray-900 mb-1">{title}</h1>
            {description && (
              <p className="text-sm text-gray-600">{description}</p>
            )}
          </div>
        </div>
        <div className="flex items-center space-x-4">
          {action && <div>{action}</div>}
        </div>
      </div>
      
      {/* Show tabs below on mobile (centered, no extra spacing) and inline on desktop */}
      {tabs && (
        <>
          <div className="md:hidden flex justify-center">
            {tabs}
          </div>
          <div className="hidden md:block absolute right-0 top-1/2 -translate-y-1/2">
            {tabs}
          </div>
        </>
      )}
    </div>
  )
}

export default PageHeader

